import * as uuid from 'uuid';
import { ConfigConstants } from '../../../config/config-constants';
import { ODataObject } from '../../../interfaces/odata-model.interface';
import { InternalInfoUtilities } from '../../../utilities/internal-info-utilities';
import { ODataLTextModel } from '../../../utilities/text-input-utilities';
import { CompositeModel } from '../../complex/composite.model';
import { CategoryModel } from './category.model';
import { InternalInfoListModel, ODataInternalInfoOutModel } from './internal-info-list.model';
import TEXT_ID = ConfigConstants.INFO_TEXTID;

const ODataFunction = 'Function';
const ODataContactName = 'ContactName';
const ODataTelephone = 'Telephone';
const ODataMobile = 'Mobile';
const ODataEmail = 'Email';
const ODataDepartment = 'Department';
const ODataNotes = 'Notes';

export class InternalInfoContactModel extends CompositeModel {
    public functionName: CategoryModel;
    public contactName: CategoryModel;
    public telephoneNumber: CategoryModel;
    public mobile: CategoryModel;
    public email: CategoryModel;
    public department: CategoryModel;
    public notes: CategoryModel;
    public uniqueId: string;

    public contactDetails: CategoryModel[];
    public contactArrayModel: InternalInfoListModel<CategoryModel>;
    public formValidationStatus: string;
    public constructor(
        functionName = '',
        contactName = '',
        telephoneNumber = '',
        mobile = '',
        email = '',
        department = '',
        note = '',
        functionalLoc: string,
    ) {
        super('Contacts');

        this.functionName = new CategoryModel(ODataFunction, functionName, functionalLoc, TEXT_ID.FUNCTION);
        this.functionName.textLine.options = {
            ...this.functionName.textLine.options,
            rows: 1,
        };

        this.contactName = new CategoryModel(ODataContactName, contactName, functionalLoc, TEXT_ID.CONTACT_NAME);
        this.contactName.textLine.options = {
            ...this.contactName.textLine.options,
            rows: 1,
        };

        this.telephoneNumber = new CategoryModel(ODataTelephone, telephoneNumber, functionalLoc, TEXT_ID.TELEPHONE);

        this.telephoneNumber.textLine.options = {
            ...this.telephoneNumber.textLine.options,
            rows: 1,
        };

        this.mobile = new CategoryModel(ODataMobile, mobile, functionalLoc, TEXT_ID.MOBILE);

        this.mobile.textLine.options = {
            ...this.mobile.textLine.options,
            rows: 1,
        };

        this.email = new CategoryModel(ODataEmail, email, functionalLoc, TEXT_ID.EMAIL);
        this.email.textLine.options = {
            ...this.email.textLine.options,
            rows: 1,
        };

        this.department = new CategoryModel(ODataDepartment, department, functionalLoc, TEXT_ID.DEPARTMENT);
        this.department.textLine.options = {
            ...this.department.textLine.options,
            rows: 1,
        };

        const five = 5;
        this.notes = new CategoryModel(ODataNotes, note, functionalLoc, TEXT_ID.NOTES);
        this.notes.textLine.options = {
            ...this.notes.textLine.options,
            rows: five,
            splitLines: false,
        };

        this.uniqueId = uuid.v4();
        this.createArrayOfAllContactDetails();

        this.contactArrayModel = <InternalInfoListModel<CategoryModel>>(
            this.set(new InternalInfoListModel<CategoryModel>('Contacts', this.contactDetails))
        );
        this.formValidationStatus = this.getValidationStatus();
    }

    private getValidationStatus(): string {
        return this.functionName.textLine.value.length > 0 &&
            this.contactName.textLine.value.length > 0 &&
            (this.email.textLine.value.length === 0 ||
                this.email.textLine.value.match(this.email.textLine.options.pattern) !== null)
            ? ConfigConstants.FORM_STATUS.VALID
            : ConfigConstants.FORM_STATUS.INVALID;
    }

    public createArrayOfAllContactDetails(): CategoryModel[] {
        this.contactDetails = [];

        this.contactDetails = [
            this.functionName,
            this.contactName,
            this.telephoneNumber,
            this.mobile,
            this.email,
            this.department,
            this.notes,
        ];
        return this.contactDetails;
    }

    public static buildContactModel(response: ODataLTextModel[], functionalLoc: string): InternalInfoContactModel[] {
        const contactLength = response.filter((contacts) => contacts.TextID === 'ZC01').length;
        const contactDetails: InternalInfoContactModel[] = [];
        // Filtering all the contact property by text id
        const functionName = InternalInfoUtilities.filterContactInfoById(response, TEXT_ID.FUNCTION);
        const infoName = InternalInfoUtilities.filterContactInfoById(response, TEXT_ID.CONTACT_NAME);
        const telephoneNumber = InternalInfoUtilities.filterContactInfoById(response, TEXT_ID.TELEPHONE);
        const mobile = InternalInfoUtilities.filterContactInfoById(response, TEXT_ID.MOBILE);
        const email = InternalInfoUtilities.filterContactInfoById(response, TEXT_ID.EMAIL);
        const department = InternalInfoUtilities.filterContactInfoById(response, TEXT_ID.DEPARTMENT);
        const notes = InternalInfoUtilities.filterContactInfoById(response, TEXT_ID.NOTES);

        for (let i = 0; i < contactLength; i++) {
            if (functionName[i]?.TextLine.length > 0 || infoName[i]?.TextLine.length > 0) {
                const contacts = new InternalInfoContactModel(
                    functionName[i]?.TextLine,
                    infoName[i]?.TextLine,
                    telephoneNumber[i]?.TextLine,
                    mobile[i]?.TextLine,
                    email[i]?.TextLine,
                    department[i]?.TextLine,
                    notes[i]?.TextLine,
                    functionalLoc,
                );
                contactDetails.push(contacts);
            }
        }
        return contactDetails;
    }

    public getOutModel(): ODataObject {
        const outModel = <ODataInternalInfoOutModel>super.getOutModel();

        outModel[this.name] = [...outModel.Contacts];

        return outModel;
    }
}
